import { render } from "./ExtraComments.vue?vue&type=template&id=71bc9331"
import script from "./ExtraComments.vue?vue&type=script&lang=js"
export * from "./ExtraComments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__